import AgoraRTC from "agora-rtc-sdk-ng";
import { db } from "../firebase/firebase";
import { doc, deleteDoc } from "firebase/firestore";

export const handleEndLive = async (
  client,
  navigate,
  isBroadcaster,
  userId,
  localCameraTrack,
  localMicrophoneTrack
) => {
  try {
    // Stop and close local tracks if they exist
    if (localCameraTrack) {
      localCameraTrack.stop();
      localCameraTrack.close();
    }
    if (localMicrophoneTrack) {
      localMicrophoneTrack.stop();
      localMicrophoneTrack.close();
    }

    // Delete live stream record from Firestore if broadcaster
    if (isBroadcaster) {
      await deleteDoc(doc(db, "live_streams", userId?.toString()));
    }

    // Leave the Agora channel
    await client.leave();

    // Navigate back
    navigate(-1);
  } catch (error) {
    console.error("Error ending live stream:", error);
    navigate(-1); // still navigate back even if there is an error
  }
};

export const toggleCamera = (
  localCameraTrack,
  cameraEnabled,
  setCameraEnabled
) => {
  if (localCameraTrack) {
    localCameraTrack.setEnabled(!cameraEnabled);
    setCameraEnabled(!cameraEnabled);
  }
};

export const flipCamera = async (localCameraTrack) => {
  if (!localCameraTrack) return;
  try {
    const cameras = await AgoraRTC.getCameras();
    if (cameras.length < 2) {
      console.log("Only one camera available");
      return;
    }
    const currentDeviceId = localCameraTrack._track.getSettings().deviceId;
    const nextCamera =
      cameras.find((cam) => cam.deviceId !== currentDeviceId) || cameras[0];
    await localCameraTrack.setDevice(nextCamera.deviceId);
  } catch (error) {
    console.error("Flip camera error:", error);
  }
};

export const toggleMicrophone = (
  localMicrophoneTrack,
  micEnabled,
  setMicEnabled
) => {
  if (localMicrophoneTrack) {
    localMicrophoneTrack.setEnabled(!micEnabled);
    setMicEnabled(!micEnabled);
  }
};

export const toggleViewerAudio = (client, isAudioMuted, setIsAudioMuted) => {
  const volume = isAudioMuted ? 100 : 0;
  client.remoteUsers.forEach((user) => {
    if (user.audioTrack) {
      user.audioTrack.setVolume(volume);
    }
  });
  setIsAudioMuted(!isAudioMuted);
};
